import { ObtieneEtapaProceso, InsertPrimeraEtapaProceso, UpdateEtapaProceso, InsertPrimeraEtapaProcesoFirma } from "../../../application/interactors/EtapasProceso";
import { createStyles, makeStyles, TableCell, TableRow, Theme, withStyles } from "@material-ui/core";

export const ObtieneEtapaProcesoLogic = (selListaParametros: any, rut: number,
  año: number,
  periodo: number,
  codigoNegocio: number,
  codigoPrograma: string,
  codigoPlanificacionAcademica: number) => {
  return ObtieneEtapaProceso(selListaParametros, rut, año, periodo, codigoNegocio, codigoPrograma, codigoPlanificacionAcademica);
}
export const InsertPrimeraEtapaProcesoLogic = (selListaParametros: any, rut: number,
  año: number,
  periodo: number,
  codigoNegocio: number,
  codigoPrograma: string,
  codigoPlanificacionAcademica: number,
  idPeriodo: number) => {
  return InsertPrimeraEtapaProceso(selListaParametros, rut, año, periodo, codigoNegocio, codigoPrograma, codigoPlanificacionAcademica, idPeriodo);
}
export const InsertPrimeraEtapaProcesoFirmaLogic = (selListaParametros: any, rut: number,
  año: number,
  periodo: number,
  codigoNegocio: number,
  codigoPrograma: string,
  codigoPlanificacionAcademica: number) => {
  return InsertPrimeraEtapaProcesoFirma(selListaParametros, rut, año, periodo, codigoNegocio, codigoPrograma, codigoPlanificacionAcademica);
}
export const UpdateEtapaProcesoLogic = (selListaParametros: any, idProceso: number, idEtapa: number, esPregradoSinRF: boolean = false) => {
  return UpdateEtapaProceso(selListaParametros, idProceso, idEtapa,esPregradoSinRF);
}
export const Link2 = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      "&[disabled]": {
        color: "grey",
        cursor: "default",
        "&:hover": {
          textDecoration: "none"
        }
      }
    }
  }),
);
export const Link3 = withStyles({
  root: {
    "&[disabled]": {
      color: "grey",
      cursor: "default",
      "&:hover": {
        textDecoration: "none"
      }
    }
  }
})